import { submitFnol } from '@/api/bpo'

const submit = (_ctx: any, data: any): Promise<any> => {
    return submitFnol(changeData(data))
}

const changeData = (data: any) => {
    const serverFormat = {
        reportingPartyNameKanji: data.c1FullName,
        reportingPartyPhone1: data.c1Tel,
        relationshipToCustomer: String(data.c1InsuRlRelation.id) || '',
        customerNameKatakana: data.c1ContractNameKana,
        customerNameKanji: data.c1ContractFullName,
        customerPhoneNumber1: data.c1HomeTel,
        customerNumberPlate: data.c1RegistraNum,
        dateOfLoss: formatDate(data.c2AccidentDate),
        timeOfLoss: formatTime(data.c2AccidentTime),
        lossLocationAddress: data.c2JikoPlace,
        driverNameKatakana: data.c2DriverNameKara,
        driverNameKanji: data.c2DriverFullName,
        driverGender: String(data.c2Sex.id) || '',
        driverDateOfBirth: formatDate(data.c2DriverDob),
        driverAge: data.c2DriverAge,
        driverPhoneNumber1: data.c2DriverTel,
        relationshipToNamedInsured: String(data.c2InsuRlRelation.id) || '',
        damagedVehicleNumberPlate: data.c2RegistraNum,
        descriptionOfDiagram: data.c2AccidentConditionText,
        other: data.c2SpecialItem,
        policyNumber: data.policyNumber,
        ReceiveFrom: '6'
      }
    return serverFormat
}

const formatDate = (date: any) => {
  if (isInvalidDate(date)) {
    return ''
  }
  const month = date.getMonth() + 1
  const formatMonth = month < 10 ? `0${month}` : month
  const day = date.getDate()
  const formatDate = day < 10 ? `0${day}` : day
  return date.getFullYear() + '' + formatMonth + '' + formatDate
}

function isInvalidDate (date: any): boolean {
  return date == null || date === '' || isNaN(date.getDate())
}

const formatTime = (timeStr: string) => {
    if (timeStr.trim().length <= 0) {
        return ''
    }
    const data = timeStr.split(':')
    return data[0] + data[1]
}

const actions = {
    submit
}

export default actions
